// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"214":"polyfills-core-js","748":"polyfills-dom"}[chunkId] || chunkId) + "." + {"214":"5798383f","482":"d593c64a","567":"9327f00f","651":"6c13ece3","748":"5d0301a7"}[chunkId] + ".chunk.js";
};